<template>
    <div class="view">

        <Head @ck="menuOpen = true">{{ $t("menu.myDoc")}}</Head>
        <div class="cont">
            <Calendar class="calendar" @sel="getMyStudyRecord"></Calendar>
            <div class="class-list">
                <div class="report bn" @click="onReport">
                    <img src="@/assets/img/increasing-stocks-graphic-of-bars.png" alt="" v-if="mime">
                    <img src="@/assets/img/chart.png" alt="" v-else> {{$t("report")}}
                </div>
                <DayDoc @ck="selctItem"></DayDoc>
            </div>
        </div>
    </div>
</template>

<script>
import mainDelegate from '@/delegate/mainDelegate'
import Calendar from '@/components/Calendar'
import DayDoc from '@/components/DayDoc'

export default {
    name: 'MyDoc',
    mixins: [mainDelegate],
    computed: {
        mime() {
            return this.$store.state.stageWw < 1000
        }
    },
    components: {
        Calendar,
        DayDoc
    },
    methods: {
        onReport() {
            window.open(process.env.REPORT + '?id=' + this.userData.Id)
        },
        selctItem(item) {
            switch (item.Stats) {
                case 0:
                    if (item.Vocabulary) {
                        //單字
                        this.word = item.Vocabulary
                    } else if (item.Exam) {
                        //測驗
                        this.examEndMata = item.Exam
                    } else {
                        alert('未定義的 Stats 類型 Vocabulary 與 Exam 均為空')
                    }
                    break
                case 1: //未完成單字練習
                    this.$router.push({ name: 'exercise' })
                    break
                case 2: //未完成單字測驗
                    this.$router.push({ name: 'test' })
                    break
                case 3:
                    this.examEndMata = item.Exam
                    break;
                default:
                    alert('未定義的 Stats 類型 =' + item.Stats)
            }
        }
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';
@import 'view.less';
.report {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 37px;
    background-color: #41beb4;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0.6px;
    text-decoration: underline;
    img {
        margin-right: 13px;
    }
}
@media only screen and (min-width: @rwd) {
    .cont {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .calendar {
            width: 45%;
        }
        .class-list {
            width: 45%;
        }
    }
    .report {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 37px;
        background-color: transparent;
        font-size: 18px;
        color: #009185;
        letter-spacing: 0.6px;
        text-decoration: underline;
        img {
            margin-right: 13px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/MyDoc.vue